import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "context/AuthContext";

function Logout() {
  const { setUser } = useContext(AuthContext); // Accessing the setUser function from AuthContext
  const navigate = useNavigate();

  useEffect(() => {
    //  Remove the token from localStorage
    localStorage.removeItem("adminToken");
    // Reset the user state in the context
    setUser(null);

    // Redirect the user to the login page
    navigate("/authentication/sign-in");
  }, [navigate, setUser]);

  return null;
}

export default Logout;
